
import { CSSProperties } from "react"

export const ListItembuttonStyle  : CSSProperties = {
    textTransform: 'none',
}

export const ListItemIconStyle  : CSSProperties = {
    marginRight: 8,
    marginLeft: 8,
    color: 'rgba(0, 0, 0, 0.6)',
    fontSize: 28,
}

export const ListTypographyStyle  : CSSProperties = {
    display: "block",
    color: 'rgba(0, 0, 0, 0.6)',
    fontFamily: 'Open Sans, Arial, sans-serif',
    fontSize: 14,
}

export const ListItemTextStyle : CSSProperties = {
    marginLeft: 15,
}

export const MenuItemStyle : CSSProperties = {
    paddingTop: 7,
    paddingBottom: 7,
}

export const DividerStyle : CSSProperties = {
    marginLeft: 20,
    marginRight: 20,
}

export const AvatarAppBarStyle : CSSProperties = {
    width: 25,
    height: 25,
}

export const TypographyAppBarStyle : CSSProperties = {    
    width: '150px',
    color: 'rgba(0, 0, 0, 0.6)',
    fontFamily: 'Open Sans, Arial, sans-serif',
    fontSize: 14,
    marginTop: 1,
}

export const TypographyPerfilAppBarStyle : CSSProperties = {    
    color: 'rgba(0, 0, 0, 0.6)', 
}

export const ListSubItemStyle : CSSProperties = {    
    alignItems: "center", 
    width: "150px", 
    paddingTop: '10px',
    paddingBottom: '10px',
    color: "inherit", 
    textDecoration: "none"
}